import React from "react";
import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { Icon } from "@tenant/ui";
import defaultStyles from "./FlightItineraryRestrictionInfo.module.scss";

export enum RestrictionSymbol {
  Included = "Included",
  Purchasable = "Purchasable",
  Unavailable = "Unavailable",
  Unknown = "Unknown",
}

export interface Restriction {
  name: string;
  description?: string;
  symbol: RestrictionSymbol;
}

export interface FlightItineraryRestrictionInfoProps {
  restriction: Restriction;
}

export const FlightItineraryRestrictionInfo = ({
  restriction,
}: FlightItineraryRestrictionInfoProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.FlightItineraryRestrictionInfo;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={block}>
      <Icon
        className={cn("restriction-icon", [restriction.symbol])}
        iconName={restrictionIconName(restriction.symbol)}
      />
      <div className={cn("restriction-name")}>{restriction.name}</div>
      {restriction.description != null ? (
        <div className={cn("restriction-description")}>
          {restriction.description}
        </div>
      ) : null}
    </div>
  );
};

const restrictionIconName = (symbol: RestrictionSymbol): IconNameEnum => {
  switch (symbol) {
    case RestrictionSymbol.Included:
      return IconNameEnum.fareDetailsAvailable;
    case RestrictionSymbol.Purchasable:
      return IconNameEnum.fareDetailsCharge;
    case RestrictionSymbol.Unavailable:
      return IconNameEnum.fareDetailsUnavailable;
    case RestrictionSymbol.Unknown:
      return IconNameEnum.fareDetailsGeneric;
  }
};
